import { render, staticRenderFns } from "./YtTextarea.vue?vue&type=template&id=81ea9966&scoped=true&"
import script from "./YtTextarea.vue?vue&type=script&lang=js&"
export * from "./YtTextarea.vue?vue&type=script&lang=js&"
import style0 from "./YtTextarea.vue?vue&type=style&index=0&id=81ea9966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ea9966",
  null
  
)

export default component.exports